import {
    notificationsByDestinataireStore
} from '../../reducers/Notification/userNotifications.reducer';
import { userNotificationStore } from '../../rootReducer';

export function getNotificationsByDestinataireId(state) {
    return state[userNotificationStore][notificationsByDestinataireStore];
}
